import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { DisplayDateTimePipe } from 'src/core/pipes/display-date-time.pipe';
import { DisplayPhoneNumberPipe } from 'src/core/pipes/display-phone-number.pipe';
import { ScheduledCallOfferDto } from '../../models/scheduled-call-offer.dto';

/** Route-wide callback alert (154880/7–8): sticky, no close button; the host decides when it shows (K-172). */
@Component({
  selector: 'app-scheduled-call-offer-toast',
  standalone: true,
  imports: [ToastModule, TooltipModule, LocalizationPipe, DisplayDateTimePipe, DisplayPhoneNumberPipe],
  templateUrl: './scheduled-call-offer-toast.component.html',
  styleUrl: './scheduled-call-offer-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduledCallOfferToastComponent {
  readonly offer = input<ScheduledCallOfferDto | null>(null);
  readonly remainingSeconds = input(0);

  readonly take = output<void>();
  readonly abandon = output<void>();

  readonly remainingSecondsText = computed(() => String(this.remainingSeconds()));

  onTake(): void {
    this.take.emit();
  }

  onAbandon(): void {
    this.abandon.emit();
  }
}
